interface IGAEvent {
  action: string
  params?: any
}

export const event = ({ action, params }: IGAEvent) => {
  // @ts-ignore
  window.gtag('event', action, params)
}
